/**
 * Returns the file name when it is one path segment.
 *
 * File storage keeps each file inside its uuid directory and accepts only a
 * single segment: no `/`, `\`, NUL, or `..`. This does not rewrite the name.
 * A server-built stem that may contain those characters goes through
 * {@link toSafeFileName} first. An extension such as `.pdf` stays. An empty
 * name is rejected.
 *
 * @param name - File name the caller is storing
 * @returns The same name when it is one path segment
 * @throws When the name is empty or contains a separator, a NUL, or `..`
 *
 * @example
 * sanitizeStorageFileName('agreement.pdf'); // 'agreement.pdf'
 * sanitizeStorageFileName('nested/a.html'); // throws
 * sanitizeStorageFileName('..'); // throws
 */
export function sanitizeStorageFileName(name: string): string {
  if (
    !name ||
    name.includes('/') ||
    name.includes('\\') ||
    name.includes('..') ||
    name.includes('\0')
  ) {
    throw new Error('File name must be one path segment');
  }

  return name;
}
